import { PickingState } from "flows/Picking/models/order/types";
import { IntlMessageId } from "shared/lang";

export function getEmployeeName(employee: { id: string; displayName: string | null }): string {
  return employee.displayName || employee.id;
}

export function getPickingStateConfig(pickingState: PickingState | string): {
  messageId: IntlMessageId;
  bg: string;
} {
  switch (pickingState) {
    case PickingState.PICKING_STATE_IN_PROGRESS:
      return {
        messageId: "components.picking.order-details.picking-state.in_progress",
        bg: "orange.500",
      };
    case PickingState.PICKING_STATE_COMPLETED:
      return {
        messageId: "components.picking.order-details.picking-state.completed",
        bg: "veggie.500",
      };
    case PickingState.PICKING_STATE_CANCELLED:
      return {
        messageId: "components.picking.order-details.picking-state.cancelled",
        bg: "grey.500",
      };
    default:
      return {
        messageId: "components.picking.order-details.picking-state.pending",
        bg: "pinkFlink.500",
      };
  }
}
